// extracted by mini-css-extract-plugin
export default {"t":"style_t__O5cXb","s":"style_s__PlZcS","s2":"style_s2__gkZRW"};